import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { hapticSelection } from '../utils/haptics';

export default function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useLanguage();

  const items = [
    { path: '/', label: t('nav.home'), icon: '🛺' },
    { path: '/earnings', label: t('nav.earnings'), icon: '💰' },
    { path: '/profile', label: t('nav.profile'), icon: '👤' },
  ];

  return (
    <nav className="driver-bottom-nav" aria-label="Main">
      {items.map((item) => {
        const active = item.path === '/'
          ? pathname === '/'
          : pathname.startsWith(item.path);
        return (
          <button
            key={item.path}
            type="button"
            className={active ? 'active' : ''}
            onClick={() => {
              if (!active) hapticSelection();
              navigate(item.path);
            }}
          >
            <span className="driver-nav-icon" aria-hidden>{item.icon}</span>
            <span className="driver-nav-label">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
